var map = {
	"./avon.webp": 2906,
	"./dal-schedule-builder.webp": 3683,
	"./dalcs.webp": 1853,
	"./github-pinner.webp": 148,
	"./joinly.webp": 1689,
	"./magic-upload.webp": 4841,
	"./onlne.webp": 1802,
	"./snack-track.webp": 5920,
	"./space-invaders.webp": 430
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9766;